export const ADA_PACKAGES = [
	'SoMePro',
	'ReachPro',
	'ReachElite',
	'ContentPremium',
];

export function hasPackageChoice(packageChoice) {
	return ADA_PACKAGES.includes(packageChoice);
}
